module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAQAAAAEAQMAAACTPww9AAAABGdBTUEAALGPC/xhBQAAAAFzUkdCAK7OHOkAAAADUExURQAAAKd6PdoAAAABdFJOU4CtXltGAAAAC0lEQVQI12NggAAAAAgAAS8g3TEAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./webserver/document_root/s/js/plugins/pinterest/img/pinterest_overlay-bg-ie.png
// module id = 931
// module chunks = 176 193 194